import { Badge } from '@chakra-ui/react'

import Person from './Person'

const CaseworkCMList = ({ casework }) => {
  if (!casework) return null

  const { district, council_members = [] } = casework
  if (!isNaN(district) && council_members.length === 0)
    return <Badge colorScheme='orange'>Vacant Office</Badge>

  return council_members.map(cm => <Person key={`cm-${cm}`} name={cm} />)
}

export default CaseworkCMList
